import { render } from "./deleted-employee.vue?vue&type=template&id=68242366"
import script from "./deleted-employee.vue?vue&type=script&lang=js"
export * from "./deleted-employee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__